import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path d="M14.382 8.05a.75.75 0 0 1 .192-1.042c.975-.673 2.502-.673 3.477 0 .468.325 1.3.325 1.773 0a.75.75 0 0 1 .852 1.234 3.25 3.25 0 0 1-3.477 0c-.468-.325-1.3-.325-1.773 0a.75.75 0 0 1-1.044-.191m5.442 1.958c-.468.325-1.3.325-1.773 0-.975-.673-2.502-.673-3.477 0a.75.75 0 1 0 .852 1.234c.468-.325 1.3-.325 1.773 0a3.25 3.25 0 0 0 3.477 0 .75.75 0 0 0-.852-1.234M12 17.75a3 3 0 1 1-3.75-2.906V5a.75.75 0 0 1 1.5 0v9.844A3.006 3.006 0 0 1 12 17.75m3 0a6 6 0 1 1-9.75-4.687V5a3.75 3.75 0 0 1 7.5 0v8.063A6 6 0 0 1 15 17.75m-1.5 0a4.5 4.5 0 0 0-1.93-3.694.75.75 0 0 1-.32-.618V5a2.25 2.25 0 0 0-4.5 0v8.438a.75.75 0 0 1-.32.614 4.5 4.5 0 1 0 7.07 3.698" />
  </>
);

const Weather36 = Icon('weather-36', svgContents);

export default Weather36;
